import { CSSProperties } from "react";

export const styles = {
	clickIcon: { cursor: 'pointer', fontSize: '150%', position: 'relative', verticalAlign: 'middle' } as CSSProperties,
	disabledClickIcon: { fontSize: '150%', position: 'relative', verticalAlign: 'middle' } as CSSProperties
};
